/** @type {BeforeInstallPromptEvent | null} */
let deferredPrompt = null;

/** @type {Set<(prompt: BeforeInstallPromptEvent | null) => void>} */
const listeners = new Set();

/**
 * @param {(prompt: BeforeInstallPromptEvent | null) => void} listener
 * @returns {() => void}
 */
export function subscribePwaInstallPrompt(listener) {
  listeners.add(listener);
  listener(deferredPrompt);
  return () => listeners.delete(listener);
}

/** @returns {BeforeInstallPromptEvent | null} */
export function getDeferredPwaInstallPrompt() {
  return deferredPrompt;
}

function notifyListeners() {
  listeners.forEach((listener) => listener(deferredPrompt));
}

export function initPwaInstallCapture() {
  if (typeof window === 'undefined' || window.__yocasPwaInstallCapture) return;
  window.__yocasPwaInstallCapture = true;

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
    notifyListeners();
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notifyListeners();
  });
}

/**
 * @returns {Promise<'accepted' | 'dismissed' | 'unavailable'>}
 */
export async function promptPwaInstall() {
  if (!deferredPrompt) return 'unavailable';

  await deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;

  if (outcome === 'accepted') {
    deferredPrompt = null;
    notifyListeners();
    return 'accepted';
  }

  return 'dismissed';
}
